// extracted by mini-css-extract-plugin
export default {"subscription__Btn":"SubscriptionForm_subscription__Btn__fUFuQ","slideUp":"SubscriptionForm_slideUp__dui0Y","slideDown":"SubscriptionForm_slideDown__RIooS"};